module.exports = __webpack_public_path__ + "img/mobileculture4.8aebd72f.png";